export default (interval = 1000) => ({
    data: () => ({
        now: null,
        timer: null,
    }),

    created() {
        this.now = this.$moment();

        this.timer = setInterval(() => {
            this.now = this.$moment();
        }, interval);
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },
});
